import React, { Component } from 'react';

import { Grid, Row, Col } from 'react-bootstrap';

import './section.css';

class Section extends Component {

    render() {
        let backgroundStyle = {
            backgroundImage: "url(" + this.props.background + ")"
        }

        let entities = this.renderSectionEntities();
        return (
            <div>
                <div className="section-background" style={backgroundStyle}>
                </div>
                <div className="section" style={{ backgroundColor: this.props.backgroundColor }}>
                    <Grid>
                        <Row className="section-wrapper">
                            <Col className="section-title">{this.props.title}</Col>
                            <Col>{entities}</Col>
                            <Col className="entry-summary">{this.props.summary}</Col>
                        </Row>
                    </Grid>
                </div>
            </div>
        );
    }

    renderSectionEntities() {
        return <Grid fluid={true} className="section-list">{
            this.props.entries.map(entry => {
                return <Row className="entry-item" key={entry.description || entry}>
                    {(entry.start) ?
                        <Col xs={12} md={3} mdOffset={1} className="entry-date">{entry.start} - {(entry.end) ? entry.end : "Present"}</Col>
                        :
                        void 0
                    }
                    {(entry.description) ?
                        <Col xs={12} md={8} className="entry-description" dangerouslySetInnerHTML={{ __html: entry.description }}></Col>
                        :
                        <Col xs={12} mdOffset={1} className="entry-list-item">{entry}</Col>
                    }
                </Row>
            })
        }</Grid>
    }
}

export default Section;



// WEBPACK FOOTER //
// ./src/components/section/section.js